<div class="ba-field-group">
    <div class="centered">
        <img [src]="asset('assets/images/canales-digitales-celular-pantalla-bloqueado.svg')"
            alt="canales digitales celular pantalla bloqueado">
    </div>
</div>
<p class="ibk-description">
    ¡Superaste el l&iacute;mite de intentos!
</p>
<div class="ba-field-group centered">
    <span>{{firstName}}, excediste la cantidad permitida de env&iacute;os de c&oacute;digo. Por tu seguridad la
        solicitud
        ha sido bloqueada.</span>
</div>
<ibk-button class="ba-action" [loading]="isLoading">
    <button id="btn-resend-code" class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn"
        (click)="exitFlowCreateAccount.emit()">
        Salir
    </button>
</ibk-button>